import { Expose, Transform } from 'class-transformer'

export class PerformanceLogCityType {
  @Expose({ name: 'cityName' }) name: string

  @Expose({ name: 'count' })
  @Transform(({ value }) => value || 0)
  value: number
}
